export const enum NotificationFilter {
  ViewAll = "all",
  Patients = "patient",
  CareTeam = "care-team",
  System = "system",
}
